/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LaundryGroupReference
 */
export interface LaundryGroupReference {
    /**
     * UUID of the Laundry Group
     * @type {string}
     * @memberof LaundryGroupReference
     */
    id: string;
    /**
     * Name of the Laundry Group
     * @type {string}
     * @memberof LaundryGroupReference
     */
    readonly name: string | null;
    /**
     * WL Number of the Laundry Group
     * @type {string}
     * @memberof LaundryGroupReference
     */
    readonly wlNumber?: string | null;
}

/**
 * Check if a given object implements the LaundryGroupReference interface.
 */
export function instanceOfLaundryGroupReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function LaundryGroupReferenceFromJSON(json: any): LaundryGroupReference {
    return LaundryGroupReferenceFromJSONTyped(json, false);
}

export function LaundryGroupReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'wlNumber': !exists(json, 'wlNumber') ? undefined : json['wlNumber'],
    };
}

export function LaundryGroupReferenceToJSON(value?: LaundryGroupReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

